import { makeStyles } from '@material-ui/core/styles'
import { Grid, Tooltip } from '@mui/material'
import Modal from 'src/components/common/Modal'
import PolicyDetailsCard from 'src/components/Individual/PolicyDetails/PolicyDetailsCard'
import AddPolicy from 'src/assets/PolicyDetails_Images/AddPolicy.svg'
import { useQuery } from '@apollo/client'
import {
  DASHBOARD_POLICIES_DATA,
  GET_CLIENT_BY_YEARS,
  GET_MASTER_DATA,
} from 'src/services/individualService'
import GraphQlErrors from 'src/components/common/GraphQlErrors'
import { useEffect, useState } from 'react'
import ViewAllDashboard from 'src/components/Individual/PolicyDetails/ViewAllDashboard'
import EmptyScreenPolicies from 'src/components/Individual/EmptyScreenPolicies'
import { getShortAmount } from 'src/utils/commonMethods'
import EmpDashboard from 'src/assets/Policy_Details_Images/EmpDashboard.svg'
import { useHistory } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import AddExistingPolicy from 'src/components/Individual/modals/AddExistingPolicy'
import {
  EXPIRY_TYPES,
  POLICY_STATUS_TYPES,
  POLICY_TYPE_ALL,
  SEARCH_PERSISTENCE_ACTION_TYPES,
  SXP_UPLOAD_POLICY_TYPE,
} from 'src/utils/constants/common'
import LoadingModal from 'src/components/common/LoadingModal'
import { COLORS } from 'src/utils/Themes/colors'
import ExpiredPolicyToolbar from 'src/components/Individual/PolicyDetails/ExpiredPolicyToolbar'
import { resetFilters, setDashboardFilters } from 'src/actions'
import { POLICY_CONSTANTS } from 'src/utils/constants/policyConstants'
import PolicyCitiesFilters from 'src/components/Individual/PolicyDetails/PolicyCitiesFilters'
import { getDashboardFilterValue } from 'src/utils/commonMethods/searchPersistence'
import { GET_POLICY_CITIES_FOR_GROUPED_POLICIES } from 'src/services/corporateService'

const PolicyDetails = ({
  clientId,
  isCorporate = false,
  addPolicy,
  isCEO,
  policyType,
  clientType,
  isUploadPolicyOpen,
  closeUploadPolicyModal,
}) => {
  const classes = useStyles()
  const history = useHistory()
  const [viewPolicy, setViewPolicy] = useState(false)
  const [selectedPolicy, setSelectedPolicy] = useState()
  const userInfo = useSelector((state) => state?.userInfo)
  const [selectedStatusType, setSelectedStatusType] = useState(
    POLICY_STATUS_TYPES?.active
  )
  const dispatch = useDispatch()

  const policyCitiesFilters = useSelector(
    (state) => state?.searchPersistenceReducer?.policyCitiesFilters
  )

  const [years, setYears] = useState([])

  const [insurance, setInsurances] = useState([])

  const userDashboardAccess = userInfo?.userInfo?.userData?.dashboardAccess

  const [expiredFilterParams, setExpiredFilterParams] = useState({
    year: '',
    policyType: '',
    subType: '',
  })

  const [cityFilters, setCityFilters] = useState({
    city: getDashboardFilterValue(policyCitiesFilters, 'city'),
  })

  const {
    loading: dashboardPoliciesAggregateLoading,
    error: dashboardPoliciesAggregateError,
    data,
    refetch,
  } = useQuery(
    DASHBOARD_POLICIES_DATA(
      clientId,
      clientType,
      selectedStatusType,
      expiredFilterParams?.year || '',
      expiredFilterParams?.policyType === POLICY_TYPE_ALL
        ? ''
        : expiredFilterParams?.policyType,
      expiredFilterParams?.subType || '',
      cityFilters?.city || ''
    ),
    {
      // skip:true,
      errorPolicy: 'all',
      fetchPolicy: 'cache-and-network',
    }
  )

  const {
    // loading: clientYearsLoading,
    // error: clientYearsError,
    data: clientYears,
  } = useQuery(GET_CLIENT_BY_YEARS(clientId), {
    errorPolicy: 'all',
    fetchPolicy: 'cache-and-network',
  })

  const {
    // loading: masterDataLoading,
    // error: masterDataError,
    data: masterData,
  } = useQuery(GET_MASTER_DATA(), {
    errorPolicy: 'all',
  })

  const insuranceTypesData = masterData?.getInsuranceTypeData

  const {
    loading: groupedPolicyCitiesLoading,
    error: groupedPolicyCitiesError,
    data: groupedPolicyCitiesData,
  } = useQuery(GET_POLICY_CITIES_FOR_GROUPED_POLICIES(clientId), {
    errorPolicy: 'all',
    fetchPolicy: 'cache-and-network',
  })

  const groupedPolicyCitiesList =
    groupedPolicyCitiesData?.getPolicyCitiesForGroupPolicies

  useEffect(() => {
    const minYear = parseInt(
      clientYears &&
        clientYears?.getExpiredPoliciesYearLimit?.data
          ?.expiredPolicyYearLimitMin,
      10
    )
    const maxYear = parseInt(
      clientYears &&
        clientYears?.getExpiredPoliciesYearLimit?.data
          ?.expiredPolicyYearLimitHigh,
      10
    )

    if (minYear && maxYear) {
      const yearRange = Array.from(
        { length: maxYear - minYear + 1 },
        (_, i) => minYear + i
      )?.reverse()
      setYears(yearRange)
      setExpiredFilterParams((prevState) => ({
        ...prevState,
        year: yearRange?.[0],
      }))
    }
  }, [clientYears])

  useEffect(() => {
    if (insuranceTypesData) {
      const filteredInsurances = insuranceTypesData?.filter((item) =>
        item?.category?.includes(clientType)
      )
      setInsurances(filteredInsurances)
    }
  }, [insuranceTypesData, clientType])

  useEffect(() => {
    dispatch(resetFilters())
    setExpiredFilterParams((prevState) => ({
      ...prevState,
      year: years?.[0],
      policyType: '',
      subType: '',
    }))
  }, [selectedStatusType, dispatch, years, cityFilters?.city])

  if (dashboardPoliciesAggregateError || groupedPolicyCitiesError)
    return (
      <GraphQlErrors
        error={dashboardPoliciesAggregateError}
        routeValue={'back'}
      />
    )

  let policyDetailsData = data?.getDashboardPoliciesAggregate

  const handleViewAll = (policyDetails, isView = false) => {
    setViewPolicy(isView)
    setSelectedPolicy(policyDetails)
  }

  const employeeManagementButtonClick = () => {
    history.push('/individual/dashboard/company/employeeManagement')
  }

  const showEmployeeManagementButton = () => {
    return userDashboardAccess.employeeManagement
  }

  const showAddPolicyButton = () => {
    return !isCorporate || userDashboardAccess.addPolicy
  }

  const policyStatusTypes = (selected) => {
    setSelectedStatusType(selected)
  }

  const isSelected = (selected) => {
    return selectedStatusType === selected
  }

  const getNoPoliciesText = () => {
    switch (selectedStatusType) {
      case POLICY_STATUS_TYPES?.verificationPending:
        return POLICY_CONSTANTS?.NO_VERIFICATION_PENDING_POLICIES
      case POLICY_STATUS_TYPES?.expiring:
        return POLICY_CONSTANTS?.NO_EXPIRING_POLICIES
      case POLICY_STATUS_TYPES?.expired:
        return POLICY_CONSTANTS?.NO_EXPIRED_POLICIES
      default:
        return
    }
  }

  const dispatchPolicyCitiesFilters = (dashboardFilters, searchText) => {
    dispatch(
      setDashboardFilters(
        SEARCH_PERSISTENCE_ACTION_TYPES?.setPolicyCitiesFilters,
        {
          ...dashboardFilters,
          searchValue: searchText,
        }
      )
    )
  }

  const applyFilters = (event) => {
    setCityFilters({
      ...cityFilters,
      ...event,
    })
    dispatchPolicyCitiesFilters(event)
  }

  return (
    <div>
      <LoadingModal
        loading={
          dashboardPoliciesAggregateLoading || groupedPolicyCitiesLoading
        }
      />
      {isUploadPolicyOpen ? (
        <Modal
          id='modal'
          bgcolor={'rgb(238, 238, 238)'}
          ordered={isUploadPolicyOpen}
          width={'60%'}
          height={'50%'}
          left={'20%'}
          top={'14%'}
          open={isUploadPolicyOpen}
          modelClosed={closeUploadPolicyModal}
        >
          <AddExistingPolicy
            clientId={clientId}
            policyType={SXP_UPLOAD_POLICY_TYPE?.CORPORATE}
            closefunction={closeUploadPolicyModal}
            path='dashboard/company'
          />
        </Modal>
      ) : null}
      {viewPolicy ? (
        <ViewAllDashboard
          clientId={clientId}
          policyDetails={selectedPolicy}
          handleBack={handleViewAll}
          isCEO={isCEO}
          policyType={policyType}
          clientType={clientType}
          path='dashboard/company'
          expiryType={selectedStatusType}
          expiredFilterParams={expiredFilterParams}
          prevCity={cityFilters?.city}
          setSelectedCity={(city) => {
            setCityFilters({ city: city })
          }}
        />
      ) : (
        <>
          <div className={classes.mainContent}>
            <Grid
              container
              spacing={1}
              className={classes.companyPoliciesHeader}
              justifyContent='center'
            >
              <Grid item xs={12} className={classes.policyStatsRow}>
                <Grid
                  container
                  spacing={1}
                  className={classes.policyStats}
                  alignItems='stretch'
                >
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    md={2}
                    lg={2}
                    xl={2}
                    className={`${classes.statsTextGrid} ${
                      isSelected(POLICY_STATUS_TYPES?.active)
                        ? classes.highlightButton
                        : null
                    }`}
                  >
                    <span
                      id='active'
                      onClick={() =>
                        policyStatusTypes(POLICY_STATUS_TYPES?.active)
                      }
                      className={classes.statsText}
                    >
                      Active:
                      <span className={classes.statsSubText}>
                        &nbsp;
                        {policyDetailsData?.activePolicies}
                      </span>
                    </span>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    md={3}
                    lg={3}
                    xl={3}
                    className={`${classes.statsTextGrid} ${
                      isSelected(POLICY_STATUS_TYPES?.verificationPending)
                        ? classes.highlightButton
                        : null
                    }`}
                  >
                    <span
                      id='verificationPending'
                      onClick={() =>
                        policyStatusTypes(
                          POLICY_STATUS_TYPES?.verificationPending
                        )
                      }
                      className={classes.statsText}
                    >
                      Verification Pending :
                      <span className={classes.statsSubText}>
                        &nbsp;
                        {policyDetailsData?.verificationPendingPolicies}
                      </span>
                    </span>
                  </Grid>

                  <Grid
                    item
                    xs={12}
                    sm={6}
                    md={2}
                    lg={2}
                    xl={2}
                    className={`${classes.statsTextGrid} ${
                      isSelected(POLICY_STATUS_TYPES?.expiring)
                        ? classes.highlightButton
                        : null
                    }`}
                  >
                    <span
                      id='expiring'
                      onClick={() =>
                        policyStatusTypes(POLICY_STATUS_TYPES?.expiring)
                      }
                      className={classes.statsText}
                    >
                      Expiring :
                      <span className={classes.statsSubText}>
                        &nbsp;
                        {policyDetailsData?.expiringPolicies}
                      </span>
                    </span>
                  </Grid>

                  <Grid
                    item
                    xs={12}
                    sm={6}
                    md={2}
                    lg={2}
                    xl={2}
                    className={`${classes.statsTextGrid} ${
                      isSelected(POLICY_STATUS_TYPES?.expired)
                        ? classes.highlightButton
                        : null
                    }`}
                  >
                    <span
                      id='expired'
                      onClick={() => {
                        policyStatusTypes(POLICY_STATUS_TYPES?.expired)
                      }}
                      className={classes.statsText}
                    >
                      Expired :
                      <span className={classes.statsSubText}>
                        &nbsp;
                        {policyDetailsData?.expiredPolicies}
                      </span>
                    </span>
                  </Grid>

                  <Grid
                    className={classes.statsTextGrid}
                    item
                    xs={12}
                    sm={6}
                    md={3}
                    lg={3}
                    xl={3}
                  >
                    <Tooltip
                      title={getShortAmount(
                        policyDetailsData?.totalPremiumAmount
                      )}
                    >
                      <span className='cursor-pointer'>
                        Total Premium:&nbsp;
                        {getShortAmount(policyDetailsData?.totalPremiumAmount)}
                      </span>
                    </Tooltip>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12}>
                <div className={classes.imageContainer}>
                  {showEmployeeManagementButton() ? (
                    <div
                      className={classes.buttonContainer}
                      onClick={employeeManagementButtonClick}
                    >
                      <img
                        src={EmpDashboard}
                        alt='EmpDashboard'
                        className={classes.image}
                      />
                      <span className={classes.imageText}>
                        Employee Management
                      </span>
                    </div>
                  ) : null}

                  {showAddPolicyButton() && (
                    <div
                      className={classes.buttonContainer}
                      onClick={addPolicy}
                    >
                      <img
                        src={AddPolicy}
                        alt='addPolicy'
                        className={classes.image}
                      />
                      <span className={classes.imageText}>Add Policy</span>
                    </div>
                  )}
                  <PolicyCitiesFilters
                    filters={cityFilters}
                    applyFilters={applyFilters}
                    id={'policyCitiesFilters'}
                    citiesList={groupedPolicyCitiesList}
                  />
                </div>
              </Grid>
            </Grid>
          </div>
          {selectedStatusType === EXPIRY_TYPES?.EXPIRED && (
            <ExpiredPolicyToolbar
              years={years}
              insurance={insurance}
              refetch={refetch}
              expiredFilterParams={expiredFilterParams}
              setExpiredFilterParams={setExpiredFilterParams}
              expired={policyDetailsData?.expiredPolicies >= 0}
            />
          )}
          {policyDetailsData?.policiesAggregate?.length ? (
            <Grid
              container
              spacing={2}
              className={classes.gridContainer}
              alignItems={'stretch'}
            >
              {policyDetailsData?.policiesAggregate?.map((data, index) => (
                <Grid item sm={12} md={6} key={`policyDetails_${index}`}>
                  <PolicyDetailsCard
                    id='policyDetailsCard'
                    policyDetails={data}
                    handleViewAll={handleViewAll}
                    index={index}
                    clientId={clientId}
                    expiryType={selectedStatusType}
                    clientType={clientType}
                    expiredFilterParams={expiredFilterParams}
                    city={cityFilters?.city}
                  />
                </Grid>
              ))}
            </Grid>
          ) : (
            <Grid item sm={12} md={12} lg={12}>
              <div className={classes.noPoliciesText}>
                {getNoPoliciesText()}
              </div>
              <EmptyScreenPolicies path='dashboard/company' />
            </Grid>
          )}
        </>
      )}
    </div>
  )
}
export default PolicyDetails
const useStyles = makeStyles({
  mainContent: {
    gap: '3%',
    display: 'flex',
    padding: '15px 0px',
    justifyContent: 'center',
    width: '100%',
  },
  tabs: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'baseline',
    flexWrap: 'wrap',
  },
  tabItem: {
    padding: '10px 0px',
    fontSize: '15px',
    color: '#000000',
    fontWeight: '500',
    lineHeight: '17px',
    cursor: 'pointer',
  },
  imageContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: '10px',
  },
  buttonContainer: {
    border: ' 1px solid #B92250',
    borderRadius: '34px',
    padding: '8px 12px',
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    cursor: 'pointer',
  },
  image: {
    width: '12px',
  },
  imageText: {
    fontSize: '13px',
    fontWeight: '600',
    color: '#B92250',
    lineHeight: '15px',
  },
  border: {
    color: '#B9B9B9',
  },
  highlightButton: {
    backgroundColor: 'rgba(185,34,80, 0.15) !important',
    opacity: '3.5 !important',
    alignItems: 'center !important',
    borderRadius: '10px',
  },
  statsSubText: {
    color: '#B92250',
  },
  statsTextGrid: {
    padding: '10px !important',
    textAlign: 'center',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    lineHeight: '1.1',
  },
  '@media (max-width: 600px)': {
    statsTextGrid: {
      borderRight: '0px',
      textAlign: 'left !important',
    },
  },
  statsText: {
    cursor: 'pointer',
    textAlign: 'center',
  },
  noPoliciesText: {
    display: 'flex',
    width: '100%',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: '18px',
    fontWeight: '500',
    color: COLORS.DARK_PINK,
    fontFamily: 'salsa',
  },
  policyStats: {
    fontSize: '15px',
    fontWeight: '500',
  },
  policyStatsRow: {
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
  },
})
